import { faHome, faUsers, faCog, faFileLines, faObjectGroup, faDonate, faCamera } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Collapse, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

const AdminSidebar = ({ isCollapsed, onExpandSidebar }) => {
    const [isLayoutOpen, setIsLayoutOpen] = useState(false);
    const [isDonationsOpen, setIsDonationsOpen] = useState(false);
    const [isPagesOpen, setIsPagesOpen] = useState(false); // Added missing state

    useEffect(() => {
        if (isCollapsed) {
            setIsLayoutOpen(false);
            setIsDonationsOpen(false);
            setIsPagesOpen(false);
        }
    }, [isCollapsed]);

    const ensureExpanded = () => {
        if (isCollapsed && typeof onExpandSidebar === "function") {
            onExpandSidebar();
        }
    };

    const handlePagesToggle = () => {
        ensureExpanded();
        setIsLayoutOpen(false);
        setIsDonationsOpen(false);
        setIsPagesOpen((prevState) => !prevState);
    };

    const handleLayoutToggle = () => {
        ensureExpanded();
        setIsPagesOpen(false);
        setIsDonationsOpen(false);
        setIsLayoutOpen((prevState) => !prevState);
    };

    const handleDonationsToggle = () => {
        ensureExpanded();
        setIsLayoutOpen(false);
        setIsDonationsOpen((prevState) => !prevState);
    };

    return (
        <div className={`admin-sidebar ${isCollapsed ? "collapsed" : ""}`}>
            <Nav className="flex-column">
                <Nav.Link as={Link} to="/bj-admin" className="admin-nav-link">
                    <FontAwesomeIcon icon={faHome} /> <span className="link-text">Dashboard</span>
                </Nav.Link>
                <Nav.Link as={Link} to="/bj-admin/media" className="admin-nav-link">
                    <FontAwesomeIcon icon={faCamera} /> <span className="link-text">Media</span>
                </Nav.Link>
                {/* <Nav.Link as={Link} to="/bj-admin/users" className="admin-nav-link">
                    <FontAwesomeIcon icon={faUsers} /> <span className="link-text">Users</span>
                </Nav.Link> */}
                
                <div className="collapsible-section">
                    <button className="admin-nav-link collapsible-btn" onClick={handlePagesToggle}>
                        <FontAwesomeIcon icon={faFileLines} /> <span className="link-text">Pages</span>
                    </button>
                    <Collapse in={isPagesOpen}>
                        <div className="sub-links">
                            <Nav.Link as={Link} to="/bj-admin/pages/home" className="sub-link">Home</Nav.Link>
                            <Nav.Link as={Link} to="/bj-admin/pages" className="sub-link">Pages</Nav.Link>
                        </div>
                    </Collapse>
                </div>
               
                <div className="collapsible-section">
                    <button className="admin-nav-link collapsible-btn" onClick={handleLayoutToggle}>
                        <FontAwesomeIcon icon={faObjectGroup} /> <span className="link-text">Layout</span>
                    </button>
                    <Collapse in={isLayoutOpen}>
                        <div className="sub-links">
                            <Nav.Link as={Link} to="/bj-admin/navbuilder" className="sub-link">Header</Nav.Link>
                            <Nav.Link as={Link} to="/bj-admin/FooterBuilder" className="sub-link">Footer</Nav.Link>
                            <Nav.Link as={Link} to="/bj-admin/SponsersBuilder" className="sub-link">Sponsors</Nav.Link>
                            <Nav.Link as={Link} to="/bj-admin/FloatingButtonBuilder" className="sub-link">Floating Button</Nav.Link>
                            <Nav.Link as={Link} to="/bj-admin/layoutBuilder" className="sub-link">Layout</Nav.Link>
                        </div>
                    </Collapse>
                </div>

                {/* Donations Collapsible Section */}
                <div className="collapsible-section">
                    <button className="admin-nav-link collapsible-btn" onClick={handleDonationsToggle}>
                        <FontAwesomeIcon icon={faDonate} /> <span className="link-text">Donations</span>
                    </button>
                    <Collapse in={isDonationsOpen}>
                        <div className="sub-links">
                            <Nav.Link as={Link} to="/bj-admin/donations" className="sub-link">Donations List</Nav.Link>
                            <Nav.Link as={Link} to="/bj-admin/donations/donors" className="sub-link">Donors</Nav.Link>
                            <Nav.Link as={Link} to="/bj-admin/donations/campaigns" className="sub-link">Campaigns</Nav.Link>
                            <Nav.Link as={Link} to="/bj-admin/donations/campaignstype" className="sub-link">Campaigns Type</Nav.Link>
                            <Nav.Link as={Link} to="/bj-admin/donations/style" className="sub-link">Style</Nav.Link>

                        </div>
                    </Collapse>
                </div>

                <Nav.Link as={Link} to="/bj-admin/settings" className="admin-nav-link">
                    <FontAwesomeIcon icon={faCog} /> <span className="link-text">Settings</span>
                </Nav.Link>
            </Nav>
        </div>
    );
};

export default AdminSidebar;
